import React from 'react'
import { observer } from 'mobx-react'
import { runInAction } from 'mobx'
import moment from 'moment'
import { Box, Link, CircularProgress } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

import { dateFormat } from 'config/callpro.config'
import { useStores } from 'config/store'
import { CallDashboardTabs, CallOutcome } from 'interfaces/Call.interface'
import { CallsStore } from 'config/store/CallPro/Call/CallsStore'

import { LinearProgress } from '../LinearProgress'
import { ChartCard } from 'components/CallPro/ChartCard'
import EmptyBarChart from '../EmptyCharts/EmptyBarChart'
import { useStyles } from './VoicemailOutcome.styles'

interface VoicemailOutcomeInterface {
  isAccordionContent?: boolean
}

type VoiceMailOutcomeType =
  CallsStore['voicemailOutcome']['records'][number]['name']

const VoicemailOutcome = (props: VoicemailOutcomeInterface) => {
  const { isAccordionContent } = props
  const { callsStore, dashboardUIStore } = useStores()
  const classes = useStyles()

  const { voicemailOutcome: _voicemailOutcome, loadingStates } = callsStore
  const voicemailOutcome = _voicemailOutcome.records
  const firstRecordDate = _voicemailOutcome.firstRecordDate
  const total = voicemailOutcome.reduce(
    (accumulator, currentElement) => accumulator + currentElement.value,
    0
  )

  const handleItemClick = (item: VoiceMailOutcomeType) => () => {
    runInAction(() => {
      const tab = CallDashboardTabs.ALL_CALLS
      const outcome = CallOutcome.ALL_CALLS
      dashboardUIStore.setCurrentTabbedOpened(tab)
      callsStore.setFilters({ outcome, voicemailOutcome: [item] })
      callsStore.setPaginationPage(1)
      callsStore.refreshAllCallsTab()
    })
  }

  return (
    <ChartCard
      headerTitle="VOICEMAIL OUTCOME"
      tooltipText="This is the result after the caller was redirected to voicemail."
      headerTotalText="Total"
      headerTotalValue={total}
      isAccordionContent={isAccordionContent}
    >
      {loadingStates.voicemailOutcome ? (
        <div
          style={{
            textAlign: 'center',
            padding: '2rem',
          }}
        >
          <CircularProgress />
        </div>
      ) : total > 0 ? (
        voicemailOutcome.map((data, key) => {
          return (
            <LinearProgress
              key={`item-${key}`}
              value={data.value}
              total={total}
              label={
                <Link
                  component="button"
                  variant="body1"
                  underline="none"
                  color="initial"
                  onClick={handleItemClick(data.name)}
                  classes={{ root: classes.link }}
                >
                  {data.name}
                </Link>
              }
            />
          )
        })
      ) : (
        <EmptyBarChart />
      )}
      {firstRecordDate.length ? (
        <div className={classes.disclaimer}>
          <InfoOutlinedIcon className={classes.disclaimerIcon} />
          The data used in this graph is derived from the calls we scored since{' '}
          {moment(firstRecordDate).format(dateFormat)}.
        </div>
      ) : null}
    </ChartCard>
  )
}

export default observer(VoicemailOutcome)
